__turbopack_context__.v({
  "icon": "action-error-module__wDd2fG__icon",
  "root": "action-error-module__wDd2fG__root",
  "text": "action-error-module__wDd2fG__text",
});
